import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4635d982")
const _hoisted_1 = { class: "plastic-source-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content-xin" }, null, -1)
const _hoisted_3 = {
  class: "head",
  ref: "card"
}
const _hoisted_4 = { class: "head-top" }
const _hoisted_5 = { class: "title lager-font" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 631@2x.png",
  class: "connect"
}, null, -1)
const _hoisted_7 = { class: "head-bottom" }
const _hoisted_8 = {
  key: 0,
  class: "text litt-font"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, "产地：", -1)
const _hoisted_10 = {
  key: 1,
  class: "text litt-font"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, "品种：", -1)
const _hoisted_12 = {
  key: 2,
  class: "text litt-font"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, "储存：", -1)
const _hoisted_14 = {
  key: 3,
  class: "text litt-font"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, "产品特点：", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "single-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://qnui.xfarmer.com/xfarmer-ui/trace/蒙版组 25@2x.png",
    alt: ""
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "single-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://qnui.xfarmer.com/xfarmer-ui/trace/蒙版组 26@2x.png",
    alt: ""
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "single-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://qnui.xfarmer.com/xfarmer-ui/trace/蒙版组 27@2x.png",
    alt: ""
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "single-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://qnui.xfarmer.com/xfarmer-ui/trace/蒙版组 28@2x.png",
    alt: ""
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "single-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://qnui.xfarmer.com/xfarmer-ui/trace/蒙版组 29@2x.png",
    alt: ""
  })
], -1)
const _hoisted_21 = { class: "tech-support" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "tech-text" }, "由极农科技提供技术支持", -1)
const _hoisted_24 = { class: "bottom-pop" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_origin_plastic_source = _resolveComponent("origin-plastic-source")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_Authentication = _resolveComponent("Authentication")!
  const _component_plant_plastic_source = _resolveComponent("plant-plastic-source")!
  const _component_process_trace = _resolveComponent("process-trace")!
  const _component_production_subject = _resolveComponent("production-subject")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_image, {
          width: "21.5625rem",
          height: "12.8125rem",
          fit: "cover",
          src: _ctx.dataInfo.productImg
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dataInfo.productName), 1)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_ctx.dataInfo.cityName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.dataInfo.cityName), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataInfo.typeName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(_toDisplayString(_ctx.dataInfo.typeName), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataInfo.store)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(_toDisplayString(_ctx.dataInfo.store), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataInfo.productInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createTextVNode(_toDisplayString(_ctx.dataInfo.productInfo), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512),
    _createVNode(_component_van_tabs, {
      "title-active-color": "#000",
      "line-width": '1.25rem',
      scrollspy: "",
      color: "#2BE1D1",
      sticky: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortArr, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
            (_ctx.dataInfo.isOpenPlace && item == 0)
              ? (_openBlock(), _createBlock(_component_van_tab, {
                  key: 0,
                  title: "产地"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16,
                    _createVNode(_component_origin_plastic_source, { dataId: _ctx.dataId }, null, 8, ["dataId"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dataInfo.isOpenCert && item == 1)
              ? (_openBlock(), _createBlock(_component_van_tab, {
                  key: 1,
                  title: "认证"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createVNode(_component_Authentication, { dataId: _ctx.dataId }, null, 8, ["dataId"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dataInfo.isOpenPlant && item == 2)
              ? (_openBlock(), _createBlock(_component_van_tab, {
                  key: 2,
                  title: "种植"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18,
                    _createVNode(_component_plant_plastic_source, { dataId: _ctx.dataId }, null, 8, ["dataId"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dataInfo.isOpenProcess && item == 3)
              ? (_openBlock(), _createBlock(_component_van_tab, {
                  key: 3,
                  title: "加工"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19,
                    _createVNode(_component_process_trace, { dataId: _ctx.dataId }, null, 8, ["dataId"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dataInfo.isOpenInfo && item == 4)
              ? (_openBlock(), _createBlock(_component_van_tab, {
                  key: 4,
                  title: "主体"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _createVNode(_component_production_subject, { dataId: _ctx.dataId }, null, 8, ["dataId"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["line-width"]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("img", {
        src: require('@/assets/logo.png'),
        alt: "极农科技",
        class: "tech-logo"
      }, null, 8, _hoisted_22),
      _hoisted_23
    ]),
    _createElementVNode("div", _hoisted_24, [
      (_ctx.pid)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onVerify && _ctx.onVerify(...args))),
            class: "btn1"
          }, "验证真伪"))
        : _createCommentVNode("", true),
      (_ctx.dataInfo.payButtonState != 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (
          _ctx.onPayment(
            _ctx.dataInfo.payType == 0 ? _ctx.dataInfo.payUrl : _ctx.dataInfo.payQrCode,
            _ctx.dataInfo.payType
          )
        )),
            class: "btn2"
          }, " 购买 "))
        : _createCommentVNode("", true)
    ])
  ]))
}